export class DateFormat {
    constructor(time) {
        this.times = new Date(time)
        this.date = this.times.getDate()
        this.month = this.times.getMonth()
        this.year = this.times.getFullYear()
    }

    display(){
        return `${this.date}/${this.month + 1}/${this.year}`
    }
}